<template>
  <fragment>
    <v-navigation-drawer
      v-model="showDrawer"
      v-click-outside="handleDrawer"
      :permanent="lgAndUp"
      color="tertiary"
      width="220"
      app
      dark
      floating
    >
      <template v-slot:prepend>
        <v-list class="pa-0">
          <v-list-item>
            <v-list-item-content class="py-0">
              <v-img
                :src="require(`@/assets/${companyLink.icon}`)"
                :alt="companyLink.name"
                :height="companyLink.height"
                :width="companyLink.width"
                :contain="companyLink.contain"
              />
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <v-list dense flat>
        <template v-for="(item, index) in sidebar">
          <v-list-group
            v-if="item.options && item.options.length > 0"
            :key="index + item.title"
            no-action
          >
            <template v-slot:activator>
              <template>
                <v-list-item-icon class="mr-6">
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </template>
            </template>
            <v-list-item
              v-for="(option, index) in item.options"
              :key="option.title + index"
              :to="{ name: option.link, params: option.params }"
              link
              class="px-4"
            >
              <v-list-item-content>
                <v-list-item-title
                  v-text="option.title"
                  style="font-size: 12px"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item
            v-else
            :key="item.title"
            :to="{ name: item.link, params: item.params }"
            link
          >
            <template>
              <v-list-item-icon class="mr-6">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
  </fragment>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import displayHelpers from "@/mixins/breakpoints.mixins";

export default {
  name: "AppProducerSideBar",
  mixins: [displayHelpers],
  data() {
    return {
      showDrawer: null,
    };
  },
  computed: {
    ...mapGetters(["storeInfo", "isEventProfile", "drawer", "userInfo"]),
    companyLink() {
      return {
        icon: "Eleven_Tickets_Negativo_Horizontal.svg",
        link: `${process.env.VUE_APP_PANEL_URL}dashboard`,
        height: 56,
        width: "100%",
        name: "eleventickets",
        contain: true,
      };
    },
    hasAffiliates() {
      return this.storeInfo?.canal_venda?.includes("MARKETPLACE");
    },
    sidebar() {
      let sidebarItems = [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard-outline",
          link: "home",
          params: {},
          options: [],
        },
        {
          title: this.$t("digital-wallet.title"),
          icon: "mdi-wallet",
          cypress: "sidebar-Carteira-Digital",
          link: "digitalWallet",
          params: {},
          options: [],
        },
        {
          title: this.$t("reports.title"),
          icon: "mdi-chart-bar",
          link: "generalAnalytical",
          params: {},
          options: [],
        },
        {
          title: this.$t("reports.eleven.daily-sales"),
          icon: "mdi-chart-bar",
          link: "consumerDailyAnalytical",
          params: {},
          options: [],
        },
        {
          title: this.$t("sales.title"),
          icon: "mdi-sale",
          cypress: "sidebar-vendas",
          link: "",
          params: {},
          options: [
            {
              title: this.$t("sales.manage"),
              cypress: "sales",
              link: "sales",
              params: {},
            },
            {
              title: this.$t("sales.discount-coupon.title"),
              cypress: "sidebar-vendas-cupom-desconto",
              link: "discountCoupon",
              params: {},
            },
            {
              title: this.$t("sales.ticket_package_title"),
              cypress: "sidebar-vendas-pacote-ingressos",
              link: "ticketPackage",
              params: {},
            },
            {
              title: "Combos",
              icon: "mdi-package-variant-closed-plus",
              cypress: "sidebar-Produtos-Combos",
              link: "combos",
              params: {},
            },
          ],
        },
        {
          title: this.$t("events.title"),
          icon: "mdi-calendar",
          cypress: "sidebar-Produtos",
          link: "",
          params: {},
          options: [
            {
              title: this.$t("events.event-config.create-edit"),
              cypress: "sidebar-Produtos-Gerenciar",
              link: "events",
              params: {},
            },
            {
              title: this.$t("events.ordering.title"),
              cypress: "sidebar-Produtos-Ordenacao",
              link: "order",
              params: {},
            },
          ],
        },
        {
          title: "Check-in",
          icon: "mdi-clipboard-check",
          cypress: "sidebar-checkin",
          link: "checkin",
          params: {},
          options: [],
        },
        {
          title: this.$t("customers.title"),
          icon: "mdi-account-heart",
          link: "consumers",
          params: {},
          options: [],
        },
        {
          title: this.$t("people.users.title"),
          icon: "mdi-account",
          link: "producersUsers",
          params: {},
          options: [],
        },
        {
          title: this.$t("registrations.integrations.title"),
          icon: "mdi-chip",
          link: "integrations",
          params: {},
          options: [],
        },
        {
          title: "Marketing",
          icon: "mdi-bullhorn",
          cypress: "sidebar-Marketing",
          link: "",
          params: {},
          options: [
            {
              title: this.$t("marketing.invitation.title"),
              link: "invitation",
              params: {},
            },
          ],
        },
      ];
      const sidebarItemsEventProfile = [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard-outline",
          link: "home",
          params: {},
          options: [],
        },
        {
          title: this.$t("digital-wallet.title"),
          icon: "mdi-wallet",
          cypress: "sidebar-Carteira-Digital",
          link: "digitalWallet",
          params: {},
          options: [],
        },
        {
          title: this.$t("reports.title"),
          icon: "mdi-chart-bar",
          link: "generalAnalytical",
          params: {},
          options: [],
        },
        {
          title: this.$t("events.title"),
          icon: "mdi-calendar-outline",
          link: "events",
          params: {},
          options: [],
        },
        {
          title: "Check-in",
          icon: "mdi-clipboard-check",
          cypress: "sidebar-checkin",
          link: "checkin",
          params: {},
          options: [],
        },
      ];
      if (this.userInfo.loja !== "31") {
        sidebarItems = sidebarItems.filter(
          item => item.title !== this.$t("reports.eleven.daily-sales")
        );
      }
      if (this.hasAffiliates) {
        sidebarItems[
          sidebarItems.findIndex(item => item.title === this.$t("sales.title"))
        ].options.push({
          title: this.$t("sales.affiliates_program"),
          icon: "mdi-handshake-outline",
          cypress: "sidebar-Vendas-programa-afiliados",
          link: "afilliatesProgram",
          params: {},
        });
        const affiliateItem = {
          title: this.$t("people.affiliates.title"),
          icon: "mdi-account-multiple",
          link: "affiliates",
          params: {},
          options: [],
        };
        sidebarItems.splice(7, 0, affiliateItem);
      }
      return this.isEventProfile ? sidebarItemsEventProfile : sidebarItems;
    },
  },
  watch: {
    drawer() {
      this.showDrawer = this.drawer;
    },
    showDrawer() {
      if (!this.showDrawer) this.toggleDrawer(false);
    },
  },
  mounted() {
    if (!this.showDrawer) this.toggleDrawer(false);
  },
  methods: {
    ...mapMutations(["toggleDrawer"]),
    handleDrawer() {
      if (!this.showDrawer) this.toggleDrawer(false);
    },
  },
};
</script>

<style scoped>
* {
  color: #ffffff !important;
}
</style>
